import { color } from '@cwos/design-tokens';
/** Resolve a severity to its token color tones. */
export function severityTones(s) {
    switch (s) {
        case 'good':
            return color.good;
        case 'look':
            return color.look;
        case 'urgent':
            return color.urgent;
        case 'unsure':
            return color.unsure;
        case 'sky':
            return { base: color.sky };
        case 'plain':
            return { base: color.ink2 };
    }
}
/**
 * The text color used for text rendered ON a status's `soft` background.
 * Families use `deep`; `plain`/`sky` use their single base. (All family pairs
 * meet ≥4.5:1 — enforced in the tokens package test.)
 */
export function softTextColor(s) {
    if (s === 'plain' || s === 'sky')
        return severityTones(s).base;
    return severityTones(s).deep;
}
/** Is this severity one of the indeterminate/attested families (must render `unsure`)? */
export function isIndeterminate(s) {
    return s === 'unsure';
}
//# sourceMappingURL=status.js.map